import moment from 'moment'

export const addTimeFromMidnihgt = (time: number, format: any): string => {
  return moment().locale('sv').startOf('day').add(time, format).format('HH:mm')
}
